// Users can shadow this file to add custom components to scope of all MDX files.
export default {}
